import type { ProcessQuestionnairesProgressStatusItem } from '@common/interfaces/api/processesApi';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { QuestionnaireResponses } from '../components/questionnaireResponses/QuestionnaireResponses';

export function addOsasQuestionnaireResults<
    ReadData extends {
        questionnaireResultsItems: ProcessQuestionnairesProgressStatusItem[];
    },
>(readSections: IProcessActivityReadSection[], map: ComponentsMap): void {
    const questionnaireProgressItems = getProcessActivityReadSectionItem<ReadData>()(
        readSections,
        'questionnaireResultsItems'
    );

    if (!questionnaireProgressItems) {
        return;
    }

    const componentToRender = (
        <QuestionnaireResponses questionnaireResponsesResults={questionnaireProgressItems.value} />
    );

    map.set(questionnaireProgressItems.key, componentToRender);
}
